export { PhoneService } from './phone.service';



// WEBPACK FOOTER //
// ./src/app/fonzi-module/services/index.ts